import { render } from "./ReadyForDelivery.vue?vue&type=template&id=6017ba10"
import script from "./ReadyForDelivery.vue?vue&type=script&lang=js"
export * from "./ReadyForDelivery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__